import React, { useState, useEffect } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { leaveService } from '../../../api/LeaveService/leaveService';
import { toast } from 'react-toastify';

const LeaveTypeView = ({ onClose, leaveType }) => {
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({ name: '', description: '', isActive: true });

  // Initialize form if editing
  useEffect(() => {
    if (leaveType) setFormData(leaveType);
  }, [leaveType]);

  const mutation = useMutation({
    mutationFn: (data) => leaveType 
      ? leaveService.updateLeaveType(leaveType.id, data) 
      : leaveService.createLeaveType(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['leaveTypes']);
      toast.success(leaveType ? "Updated successfully!" : "Created successfully!");
      onClose();
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate(formData);
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <form className="modal-content" onSubmit={handleSubmit}>
          <div className="modal-header">
            <h5 className="modal-title">{leaveType ? 'Edit' : 'Add'} Leave Type</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label>Name</label>
              <input 
                className="form-control" 
                value={formData.name} 
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
            </div>
            <div className="mb-3">
              <label>Description</label>
              <textarea 
                className="form-control" 
                value={formData.description || ''} 
                onChange={(e) => setFormData({...formData, description: e.target.value})}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary" disabled={mutation.isLoading}>
              {mutation.isLoading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LeaveTypeView;